import { AbstractParentEntity } from "./AbstractParentEntity";
import { DicCompany } from "./base_DicCompany";
import {ICompanyEntity} from "../interface/ICompanyEntity";
export class AbstractDictionary extends AbstractParentEntity implements ICompanyEntity{
  company?: DicCompany | null;
  langValue1?: string | null;
  description1?: string | null;
  langValue2?: string | null;
  description2?: string | null;
  langValue3?: string | null;
  description3?: string | null;
  langValue4?: string | null;
  description4?: string | null;
  langValue5?: string | null;
  description5?: string | null;
  startDate?: any | null;
  endDate?: any | null;
  code?: string | null;
  isSystemRecord?: boolean | null;
  active?: boolean | null;
  isDefault?: boolean | null;
  order?: number | null;
  langValue?: string | null;
  description?: string | null;
}
